import Hls from 'hls.js/dist/hls';

export default {

	init() {
		const video = Array.from(document.querySelectorAll('[data-video-manifest]'));
		video.forEach((elm) => {
			const hls = new Hls();
			const source = elm.dataset.videoManifest;
			if (Hls.isSupported()) {
				hls.on(Hls.Events.ERROR, (event, data) => {
					console.error(event, data);
				});
				hls.loadSource(source);
				hls.attachMedia(elm);
				hls.on(Hls.Events.MEDIA_ATTACHED, () => {
					elm.muted = true;
					elm.play();
				});
			} else if (elm.canPlayType("application/vnd.apple.mpegurl")) {
				elm.src = source;
				elm.play();
			}
		});
	},

};
